'use strict';

var _regeneratorRuntime = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _require = require('buffer'),
    BufferConstants = _require.constants;

var stream = require('stream');

var _require2 = require('util'),
    promisify = _require2.promisify;

var bufferStream = require('./buffer-stream');

var streamPipelinePromisified = promisify(stream.pipeline);

var MaxBufferError =
/*#__PURE__*/
function (_Error) {
  _inherits(MaxBufferError, _Error);

  function MaxBufferError() {
    var _this;

    _classCallCheck(this, MaxBufferError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MaxBufferError).call(this, 'maxBuffer exceeded'));
    _this.name = 'MaxBufferError';
    return _this;
  }

  return MaxBufferError;
}(_wrapNativeSuper(Error));

function getStream(inputStream, options) {
  var _options, maxBuffer, stream;

  return _regeneratorRuntime.async(function getStream$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (inputStream) {
            _context2.next = 2;
            break;
          }

          throw new Error('Expected a stream');

        case 2:
          options = _objectSpread({
            maxBuffer: Infinity
          }, options);
          _options = options, maxBuffer = _options.maxBuffer;
          stream = bufferStream(options);
          _context2.next = 7;
          return _regeneratorRuntime.awrap(new Promise(function (resolve, reject) {
            var rejectPromise = function rejectPromise(error) {
              // Don't retrieve an oversized buffer.
              if (error && stream.getBufferedLength() <= BufferConstants.MAX_LENGTH) {
                error.bufferedData = stream.getBufferedValue();
              }

              reject(error);
            };

            (function _callee() {
              return _regeneratorRuntime.async(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 3;
                      return _regeneratorRuntime.awrap(streamPipelinePromisified(inputStream, stream));

                    case 3:
                      resolve();
                      _context.next = 9;
                      break;

                    case 6:
                      _context.prev = 6;
                      _context.t0 = _context["catch"](0);
                      rejectPromise(_context.t0);

                    case 9:
                    case "end":
                      return _context.stop();
                  }
                }
              }, null, null, [[0, 6]]);
            })();

            stream.on('data', function () {
              if (stream.getBufferedLength() > maxBuffer) {
                rejectPromise(new MaxBufferError());
              }
            });
          }));

        case 7:
          return _context2.abrupt("return", stream.getBufferedValue());

        case 8:
        case "end":
          return _context2.stop();
      }
    }
  });
}

module.exports = getStream;

module.exports.buffer = function (stream, options) {
  return getStream(stream, _objectSpread({}, options, {
    encoding: 'buffer'
  }));
};

module.exports.array = function (stream, options) {
  return getStream(stream, _objectSpread({}, options, {
    array: true
  }));
};

module.exports.MaxBufferError = MaxBufferError;